import { useEffect } from 'react';
import Hero from './components/Hero';
import PlatformShowcase from './components/PlatformShowcase';
import ServicesFeature from './components/ServicesFeature';
import BlueprintUpload from './components/BlueprintUpload';
import TechnologyGrid from './components/TechnologyGrid';
import SchedulingSection from './components/SchedulingSection';
import ContactConsultation from './components/ContactConsultation';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import { useSchemaOrg } from '../../utils/seo';

export default function HomePage() {
  // Organization Schema
  useSchemaOrg({
    type: 'Organization',
    data: {
      name: 'RDM Security',
      description: 'Premium home automation solutions specializing in Control4, Savant, RTI, and Brilliant systems with enterprise-grade infrastructure in South East Florida and West Coast Tampa South',
      telephone: '+17862829701',
      email: 'moshe@rdmsecurity.com',
      url: import.meta.env.VITE_SITE_URL || 'https://example.com',
      areaServed: [
        {
          '@type': 'State',
          name: 'Florida',
          description: 'South East Florida and West Coast Tampa South'
        }
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
          opens: '08:00',
          closes: '18:00'
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Friday',
          opens: '08:00',
          closes: '15:00'
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday', 'Sunday'],
          opens: '00:00',
          closes: '23:59',
          description: 'Emergency Calls Only'
        }
      ],
      priceRange: '$$$',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Home Automation Services',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Control4 Home Automation Installation',
              description: 'Professional Control4 smart home system installation and integration'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Savant Home Automation',
              description: 'Premium Savant automation system setup and configuration'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Fiber Optic Installation',
              description: 'Enterprise-grade fiber optic network infrastructure installation'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Security Camera Installation',
              description: 'Professional security camera system installation and monitoring'
            }
          }
        ]
      }
    }
  });

  // LocalBusiness Schema
  useSchemaOrg({
    type: 'LocalBusiness',
    data: {
      '@type': 'ElectronicsStore',
      name: 'RDM Security',
      image: 'https://example.com/logo.png',
      telephone: '+17862829701',
      email: 'moshe@rdmsecurity.com',
      priceRange: '$$$',
      areaServed: {
        '@type': 'State',
        name: 'Florida',
        description: 'South East Florida and West Coast Tampa South'
      }
    }
  });

  // WebPage Schema
  useSchemaOrg({
    type: 'WebPage',
    data: {
      name: 'Premium Home Automation South East Florida | RDM Security',
      description: 'Transform your property with premium home automation solutions. Certified Control4, Savant, RTI, Brilliant installation.',
      url: '/'
    }
  });

  useEffect(() => {
    document.title = 'South East Florida Home Automation Control4 Savant RTI Brilliant | RDM Security';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <PlatformShowcase />
      <ServicesFeature />
      <BlueprintUpload />
      <TechnologyGrid />
      <SchedulingSection />
      <ContactConsultation />
      <AboutUs />
      <Footer />
    </div>
  );
}
